import { render, staticRenderFns } from "./Forget.vue?vue&type=template&id=78851e5c&scoped=true&"
import script from "./Forget.vue?vue&type=script&lang=js&"
export * from "./Forget.vue?vue&type=script&lang=js&"
import style0 from "../../components/common/css/Auth.css?vue&type=style&index=0&id=78851e5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78851e5c",
  null
  
)

export default component.exports